export const CHARGES_CUSTOMER_CONTROLLER_ROOT_PATH = "/customer";

export const CHARGES_CUSTOMER_GET_POST_CHECKOUT_CHARGES_PATH_SUFFIX = "/post-checkout-charges";
export const CHARGES_CUSTOMER_GET_POST_CHECKOUT_CHARGES_PATH_SUFFIX_LEGACY = "/post-checkout-charges-legacy";
/** /customer/post-checkout-charges */
export const CHARGES_CUSTOMER_GET_POST_CHECKOUT_CHARGES_PATH = `${CHARGES_CUSTOMER_CONTROLLER_ROOT_PATH}${CHARGES_CUSTOMER_GET_POST_CHECKOUT_CHARGES_PATH_SUFFIX}`;
export const CHARGES_CUSTOMER_GET_POST_CHECKOUT_CHARGES_PATH_LEGACY = `${CHARGES_CUSTOMER_CONTROLLER_ROOT_PATH}${CHARGES_CUSTOMER_GET_POST_CHECKOUT_CHARGES_PATH_SUFFIX_LEGACY}`;
